import BlockCalculator from "./InformationCalculator";

export type WeeklyInflationPoint = {
  date: Date;
  annualInflationRate: number;
  emissionBtc: number;
  weeklyIssuanceBtc: number;
};

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const DAYS_PER_WEEK = 7;
const BLOCKS_PER_DAY = 144;
const BLOCKS_PER_WEEK = BLOCKS_PER_DAY * DAYS_PER_WEEK;
const GENESIS_BLOCK_DATE = new Date("2009-01-03T00:00:00Z");

export const getEstimatedBlockHeightForDate = (date: Date) => {
  const diffMs = date.getTime() - GENESIS_BLOCK_DATE.getTime();
  const diffDays = Math.max(0, diffMs / MS_PER_DAY);
  return Math.floor(diffDays * BLOCKS_PER_DAY);
};

export const buildWeeklyInflationSeries = (endDate: Date) => {
  const points: WeeklyInflationPoint[] = [];
  const startTime = GENESIS_BLOCK_DATE.getTime();
  const endTime = endDate.getTime();
  const stepMs = DAYS_PER_WEEK * MS_PER_DAY;

  for (let t = startTime + stepMs; t <= endTime; t += stepMs) {
    const date = new Date(t);
    const blockHeight = getEstimatedBlockHeightForDate(date);
    const emissionBtc = BlockCalculator.calculateCurrentEmission(blockHeight);
    const rewardPerBlock = BlockCalculator.getCurrentBlockReward(blockHeight);
    const weeklyIssuanceBtc = rewardPerBlock * BLOCKS_PER_WEEK;
    const annualizedIssuanceBtc = weeklyIssuanceBtc * 52;
    const annualInflationRate =
      emissionBtc > 0 ? (annualizedIssuanceBtc / emissionBtc) * 100 : 0;

    points.push({
      date,
      annualInflationRate,
      emissionBtc,
      weeklyIssuanceBtc,
    });
  }

  return points;
};

export const getGenesisDate = () => new Date(GENESIS_BLOCK_DATE.getTime());
